import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const OwnLibrary = ({ locale }) => {
  const translations = useTranslations();

  return (
    <View locale={locale === 'ru' ? 'ru' : 'en'} isDe={locale === 'de'}>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.own-library.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.own-library.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 244px;
  color: ${Colors.main_black};
  border-radius: 15.13px;
  background: ${(p) => `image-set(
        url('/images/mainpage/own-library-bg-mob-${p.locale}.webp') type('image/webp'),
        url('/images/mainpage/own-library-bg-mob-${p.locale}.png') type('image/png')
      )
      16px 100% / 190px auto no-repeat`},
    #f0efef;

  @media ${Points.tablet_landscape} {
    padding: 30px 30px 165px;
    background: ${(p) =>
      p.isDe === 'de'
        ? `image-set(url('/images/mainpage/own-library-bg-tab-${p.locale}.webp') type('image/webp'), url('/images/mainpage/own-library-bg-tab-${p.locale}.png') type('image/png')) 30px 120% / 190px auto no-repeat, #F0EFEF`
        : `image-set(url('/images/mainpage/own-library-bg-tab-${p.locale}.webp') type('image/webp'), url('/images/mainpage/own-library-bg-tab-${p.locale}.png') type('image/png')) 30px 100% / 190px auto no-repeat, #F0EFEF`};
  }

  @media ${Points.laptop_wide} {
    padding: 40px;
    background: ${(p) =>
      p.isDe === 'de'
        ? `image-set(url('/images/mainpage/own-library-bg-lap-${p.locale}.webp') type('image/webp'), url('/images/mainpage/own-library-bg-lap-${p.locale}.png') type('image/png'))30px 120% / 251px auto no-repeat, #f0efef`
        : `image-set(url('/images/mainpage/own-library-bg-lap-${p.locale}.webp') type('image/webp'), url('/images/mainpage/own-library-bg-lap-${p.locale}.png') type('image/png')) 30px 100% / 251px auto no-repeat, #f0efef`};
    border-radius: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }
`;
